<template>
  <div id="facelogin">
    <h1 class="title is-1">{{FaceisDetected}}</h1>
    <p>{{FaceisDetected}}</p>
    <div class="content-cam">
      <div class="camera-wrp sec">
        <video width="320" height="320" ref="videoDom" id="video_cam" preload autoplay loop muted></video>
        <canvas width="320" height="320" ref="canvasDOM" id="face_detect"></canvas>
        <div class="control-btn"></div>
      </div>
      <div class="images-wrp sec">
        <!-- <p class="title is-5">Image taken</p> -->
        <div
          :class="`img-item img-item-${index}`"
          v-for="(image, index) in images"
          :key="`img-wrp-${index}`"
          :style="`background-image: url('${image}')`"
        ></div>
        <!-- <img :src="imgUrl" alt=""> -->
      </div>
    </div>
  </div>
</template>

<script>
require('tracking/build/tracking-min.js')
  require('tracking/build/data/face-min.js')
  require('tracking/build/data/mouth-min.js')
  require('tracking/examples/assets/stats.min.js')
export default {
    name: 'facelogin',
    data() {
    return {
        count: 0,
        isdetected: '请您保持脸部在画面中央',
        videoEl: {},
        canvasEL: {},
        images: [],
        imgUrl: '',
        trackCcv: false,
        trackTracking: false,
        autoCaptureTrackTraking: false,
        userMediaConstraints: {
            audio: false,
            video: {
                // ideal（应用最理想的）
                width: {
                    min: 320,
                    ideal: 1280,
                    max: 1920
                },
                height: {
                    min: 240,
                    ideal: 720,
                    max: 1080
                },
                // frameRate受限带宽传输时，低帧率可能更适宜
                frameRate: {
                    min: 15,
                    ideal: 30,
                    max: 60
                },
                // 摄像头翻转
                facingMode: 'user'                  
                }
            }
        }
    },
    computed: {
        FaceisDetected() {
            return this.isdetected
        }
    },
    
    mounted() {
        // The getUserMedia interface is used for handling camera input.
        // Some browsers need a prefix so here we're covering all the options
        navigator.getMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia
        this.init()
    },
    methods: {
        async init() {
            this.videoEl = this.$refs.videoDom
            this.canvasEL = this.$refs.canvasDOM
            await navigator.mediaDevices
            .getUserMedia(this.userMediaConstraints)
            .then(this.getMediaStreamSuccess)
            .catch(this.getMediaStreamError)
            await this.onPlay()
        },
        async onPlay() {
            // debugHelper.log('onPlay')

            this.onTrackTracking()
        },
        
        onTrackTracking() {
            const context = this
            const video = this.videoEl
            const canvas = this.canvasEL
            const rect = {}
            const canvasContext = canvas.getContext('2d')
            let tracker = new tracking.ObjectTracker('face')
            video.pause()
            video.src = ''
            tracker.setInitialScale(4)
            tracker.setStepSize(2)
            tracker.setEdgesDensity(0.1)
            tracking.track('#video_cam', tracker, { camera: true })
            tracker.on('track', function(event) {
            const { autoCaptureTrackTraking } = context
            canvasContext.clearRect(0, 0, canvas.width, canvas.height)
                event.data.forEach(function(rect) {
                    canvasContext.strokeStyle = '#a64ceb';
                    console.log(rect)
                    rect = rect
                    canvasContext.strokeRect(rect.x, rect.y, rect.width, rect.height);
                    canvasContext.font = '11px Helvetica';
                    canvasContext.fillStyle = "#fff";
                    canvasContext.fillText('x: ' + rect.x + 'px', rect.x + rect.width + 5, rect.y + 11);
                    canvasContext.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 22);
                });
                if (event.data.length>0) {
                    // console.log(event)
                    if (context.count < 0) context.count = 0
                        context.count += 1
                        if (context.count > 6) {
                            // console.log('已检测到人脸')
                            // video.pause()
                            var videoElement = document.getElementById('video_cam')
                            var curcanvas = document.createElement("canvas");     
                            // curcanvas.width = videoElement.videoWidth;
                            // curcanvas.height = videoElement.videoHeight;
                            curcanvas.getContext('2d').drawImage(videoElement, 0, 0, rect.width, rect.height);
                            // var img = document.createElement("img");
                            context.imgUrl = curcanvas.toDataURL("image/png");
                            // console.log(curcanvas.toDataURL("image/png"))

                            context.isdetected = '已检测到人脸，正在登录'
                            // setTimeout(() => {
                            //     context.onPlay()
                            // }, 2000);
                    }
                } else {
                    context.count -= 1
                    if (context.count < 0) context.isdetected = '请您保持脸部在画面中央'
                    //this.isdetected = '已检测到人脸，正在登录'
                }
            
            })
        },
        getMediaStreamSuccess(stream) {
            window.stream = stream // make stream available to browser console
            this.videoEl.srcObject = stream
        },
        // 视频媒体流失败
        getMediaStreamError(error) {
            alert('视频媒体流获取错误' + error)
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/face.vue